(() => {
  const targetNode = document.querySelector('.ProductMeta__PriceList.Heading');
  if (!targetNode) return;
  new MutationObserver(() => {
    if (targetNode.children.length > 2) targetNode.children[0].style.display = 'none';
  }).observe(targetNode, {childList: true});
})();
//# sourceMappingURL=/cdn/shop/t/24/assets/custom.js.map
